import {
  faScaleBalanced,
  faPeopleRoof,
  faBuilding,
  faUserInjured,
  faBan,
  faHouseChimney,
  faCar,
  faGavel,
} from "@fortawesome/free-solid-svg-icons";
import {
  faLinkedin,
  faSquareFacebook,
} from "@fortawesome/free-brands-svg-icons";

export const firmName = "וידבסקי ושות׳";
export const firmFullName = "משרד עו״ד וידבסקי ושות׳";

export const siteUrl = "https://www.lawidawski.co.il";
export const defaultOgImage = `${siteUrl}/img/logo.jpg`;
export const siteLocale = "he_IL";

export const contact = {
  email: "kfirw@lawidawski.co.il",
  phones: [
    { label: "08-6270055", href: "tel:+97286270055", e164: "+972-8-6270055" },
    { label: "052-8264274", href: "tel:+972528264274", e164: "+972-52-8264274" },
  ],
  address: "רח' הרצל 118, קומה 2, ללא מעלית, באר שבע",
  streetAddress: "הרצל 118",
  addressLocality: "באר שבע",
  postalCode: "8444717",
  addressCountry: "IL",
  geo: { lat: 31.242923, lng: 34.788687 },
  openingHours: "Su-Th 09:00-18:00",
  priceRange: "₪₪",
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3411.19865026434!2d34.78868717629593!3d31.242923674342236!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x150266140599f7ff%3A0xcf9b8e60f3fe96d1!2sHerzl%20St%20118%2C%20Beersheba!5e0!3m2!1sen!2sil!4v1723396296742!5m2!1sen!2sil",
};

export const navItems = [
  { id: "home", label: "בית" },
  { id: "about", label: "אודות" },
  { id: "team", label: "צוות" },
  { id: "services", label: "שירותים" },
  { id: "why-us", label: "למה אנחנו?" },
  { id: "contact", label: "צור קשר" },
];

export const services = [
  {
    slug: "litigation",
    title: "ליטיגציה ויישוב סכסוכים",
    description:
      "ייצוג, ליווי וייעוץ משפטי בכל סוגי ההליכים בפני כל ערכאה, לרבות הליכי בוררות וגישור.",
    icon: faScaleBalanced,
    href: "/services/litigation",
  },
  {
    slug: "real-estate",
    title: "נדל\"ן ומיסוי מקרקעין",
    description:
      "ייצוג, ליווי וייעוץ משפטי בהליכי מכירת או רכישת מקרקעין ודירות, מיסוי מקרקעין ועוד.",
    icon: faHouseChimney,
    href: "/services/real-estate",
  },
  {
    slug: "traffic",
    title: "תעבורה",
    description:
      "ייצוג, ליווי וייעוץ משפטי בעבירות תעבורה, תאונות דרכים, הפחתת נקודות, קנסות ועוד.",
    icon: faCar,
    href: "/orech-din-taaruva",
  },
  {
    slug: "torts",
    title: "נזיקין",
    description:
      "ייצוג, ליווי וייעוץ משפטי בתביעות נזיקין, תאונות דרכים, תאונות עבודה ורשלנות רפואית.",
    icon: faUserInjured,
    href: "/services/torts",
  },
  {
    slug: "family",
    title: "דיני משפחה",
    description:
      "ייצוג, ליווי וייעוץ משפטי בנושאי גירושין, הסכמי ממון, צוואות, ירושות, ייפוי כוח מתמשך, מסמך הבעת רצון, הנחיות מקדימות למינוי אפוטרופוס, תומך בקבלת החלטות ועוד.",
    icon: faPeopleRoof,
    href: "/services/family",
  },
  {
    slug: "commercial",
    title: "משפט מסחרי ותאגידי",
    description:
      "ייצוג, ליווי וייעוץ משפטי לעסקים, חברות, לרבות חברות הזנק (סטארט-אפ), עריכת חוזים, הקמת חברות, ליווי שוטף ועוד.",
    icon: faBuilding,
    href: "/services/commercial",
  },
  {
    slug: "insolvency",
    title: "חדלות פירעון \nופשיטות רגל",
    description:
      "ייצוג, ליווי וייעוץ משפטי בהליכי חדלות פירעון ופשיטות רגל (של חברות ושל יחידים), הסדרי נושים, השגת הפטר מלא או חלקי מחובות ועוד.",
    icon: faBan,
    href: "/services/insolvency",
  },
  {
    slug: "enforcement",
    title: "הוצאה לפועל",
    description:
      "ייצוג, ליווי וייעוץ משפטי בהליכי הוצאה לפועל, גביית חובות, הוצאה לפועל של פסקי דין, בקשה לביצוע שטרות (שיק), הליכי מימוש נכסים ועוד.",
    icon: faGavel,
    href: "/services/enforcement",
  },
];

export const social = [
  { label: "פייסבוק", icon: faSquareFacebook, link: "https://www.facebook.com/" },
  { label: "לינקדאין", icon: faLinkedin, link: "https://www.linkedin.com/" },
];
